<template lang="pug">
modal#qualified-signature-list-certificates-plugin-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='!certificate'
  :process-button-label='$t("button.ok")'
  :title='$t("modal.qualifiedSignatureListCertificatesPlugin.title")'
  @process='onProcess'
  data-bs-backdrop='static'
  data-bs-keyboard='false'
  ref='modal'
  size='lg'
)
  p(v-if='userEmail') {{ $t('modal.qualifiedSignatureListCertificatesPlugin.message') }}
    | <strong class='ms-1'>{{ userEmail }}</strong>.
  p(v-else) {{ $t('modal.qualifiedSignatureListCertificatesPlugin.message') }}

  template(v-if='certificates.length > 0')
    .card-list
      .card(v-for='(item, index) in certificates')
        label.card-body(:for='`radio - ${item.Id}`')
          .d-flex
            .form-check
              input.form-check-input(
                :id='`radio - ${item.Id}`'
                :value='item'
                type='radio'
                v-model='certificate'
              )
            .ms-2.w-100
              div Certificado: {{ item.CommonName }}
              .d-flex
                .me-1 E-mail: {{ item.Email }}
                .ms-auto Validade: {{ item.NotAfter | dateTime }}
  template(v-else)
    h5 Nenhum certificado disponível.
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import CardTable from '@/ui/organisms/CardTable.vue';

export default {
  name: 'QualifiedSignatureListCertificatesPluginModal',
  components: {
    Modal,
    CardTable,
  },
  props: {
    certificates: {
      type: Array,
      required: true,
    },
    userEmail: {
      type: String,
    },
  },
  data() {
    return {
      certificate: '',
    };
  },
  methods: {
    onProcess() {
      this.$emit('certificate-selected', this.certificate);
    },
  },
};
</script>
<style lang="stylus">
.qualified-signature-list-certificates-plugin-modal
  .card-list
    .card
      border-radius: 0
      margin-top: -1px
      &:first-child
        border-top-left-radius: .188rem
        border-top-right-radius: .188rem
        margin-top: 0
      &:last-child
        border-bottom-left-radius: .188rem
        border-bottom-right-radius: .188rem
</style>
